import Forms from '@/components/forms/Forms'
import StageRepository from '@/shared/http/repositories/business/stage'
import PciDicRepository from '@/shared/http/repositories/pci/pcidic'
import actionsForm from '@/shared/mixins/actionsForm'
import Data from '@/shared/models/pci/pcidictionarymodel'
import { loading, toast } from '@/shared/utils/UIHelper'
import { AgGridVue } from 'ag-grid-vue'
import { debounce } from 'lodash'
import gridMixin from '../mixins/gridMixin'
import Form from './dictionary-form'

export default {
  name: 'Dictionaries',
  mixins: [actionsForm, gridMixin],
  components: {
    AgGridVue,
    Forms
  },
  data () {
    return {
      objList: [],
      data: Data,
      form: Form,
      stages: [],
      searchName: '',
      gridApi: null,
      rowSelected: null,
      dicGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          sortable: true,
          suppressMovable: true,
          lockVisible: true,
          minWidth: 30
        }
      },
      dicColumnDefs: [
        {
          headerName: 'Codigo',
          field: 'codigo',
          menuTabs: ['filterMenuTab'],
          type: 'textColumn',
          flex: 30
        },
        {
          headerName: 'Entidade',
          menuTabs: ['filterMenuTab'],
          type: 'textColumn',
          valueGetter: params => {
            return params.data.entidade === 1 ? 'Contas Receber' : 'PO'
          },
          flex: 200
        },
        {
          headerName: 'Nome',
          field: 'nome',
          menuTabs: ['filterMenuTab'],
          type: 'textColumn',
          flex: 300
        }
        // ,
        // {
        //   headerName: 'Lin.Cand.',
        //   field: 'linhaCandidato',
        //   menuTabs: ['filterMenuTab'],
        //   type: 'booleanColumn',
        //   flex: 30
        // }
      ]
    }
  },
  methods: {
    onLoad () {
      this.onClearForm()
      this.loadAllDictonary()
      this.loadAllState()
    },
    onGridReady (params) {
      this.gridApi = params.api
    },
    onClearForm () {
      this.form.etapaID.options = []
      this.onClear()
    },
    onSaveForm () {
      this.onSave()
    },
    onCreate () {
      loading.push()
      this.data.empresaID = this.company.id
      this.data.codigo = 0
      PciDicRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.onLoad()
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch((err) => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdate () {
      // toast.info('Não é possível alterar um dicionário')
      loading.push()
      this.data.empresaID = this.company.id
      this.data.codigo = 0
      PciDicRepository.Update(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.onLoad()
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch((err) => this.onException(err))
        .finally(() => loading.close())
    },
    onDelete () {
      loading.push()
      PciDicRepository.Delete(this.rowSelected.id)
        .then(response => {
          if (response.data.code > 0) {
            this.onLoad()
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch((err) => this.onException(err))
        .finally(() => loading.close())
    },
    onSelectRow (data) {
      this.rowSelected = data.api.getSelectedRows().length > 0 ? data.api.getSelectedRows()[0] : null
      if (this.rowSelected) {
        this.onSelect()
      } else {
        this.onClearForm()
      }
    },
    onSelect () {
      loading.push()
      PciDicRepository.Get(this.rowSelected.id)
        .then(response => {
          if (response.data.code > 0) {
            this.onEdit(response.data.data)
            this.processEntity(response.data.data.entidade)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch((err) => this.onException(err))
        .finally(() => loading.close())
    },
    onSelectEntity () {
      this.form.etapaID.options = []
      this.processEntity(this.form.entidade.value)
    },
    processEntity (entity) {
      const stages = this.stages.filter(st => (this.form.etapaID.value && st.id === this.form.etapaID.value) || !this.objList.some(dc => dc.etapaID === st.id))
      this.form.itens = []
      if (entity === 1) {
        this.form.etapaID.options = stages.filter(s => s.itemRecebimento || s.itemFaturamento)
        this.form.itens.value = [
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 10, pciDicID: this.data.id, nome: 'VALOR'},
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 11, pciDicID: this.data.id, nome: 'NF'},
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 12, pciDicID: this.data.id, nome: 'EMISSÃO'},
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 13, pciDicID: this.data.id, nome: 'RECEBIMENTO'}
        ]
      }
      if (entity === 2) {
        this.form.etapaID.options = stages.filter(s => s.itemPedido)
        this.form.itens.value = [
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 20, pciDicID: this.data.id, nome: 'VALOR'},
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 21, pciDicID: this.data.id, nome: 'ITEM'},
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 22, pciDicID: this.data.id, nome: 'LANCAMENTO'},
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 23, pciDicID: this.data.id, nome: 'PEDIDO'},
          {id: '00000000-0000-0000-0000-000000000000', propriedade: 24, pciDicID: this.data.id, nome: 'DESCRIÇÃO'}
        ]
      }
    },
    onSelectStage () {
      const stage = this.stages.filter(st => st.id === this.form.etapaID.value)
      const name = stage.length ? stage[0].nome + ' (' + stage[0].codigo + ')' : ''
      this.form.nome.value = name
    },
    loadAllDictonary (name) {
      loading.push()
      PciDicRepository.GetAll(this.company.id, name)
        .then(response => {
          if (response.data.code > 0) {
            this.objList = response.data.data
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch((err) => this.onException(err))
        .finally(() => loading.close())
    },
    loadAllState () {
      loading.push()
      StageRepository.GetAllByName(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.stages = response.data.data
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    }
  },
  watch: {
    searchName: debounce(function (value) {
      this.loadAllDictonary(value)
    }, 800)
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/dictionaries/dictionaries.js